import { TabSelector } from "components/global/tabselector";
import AboutIconSVG from "assets/svg/about-icon-svg";
import LineVerticalSVG from "assets/svg/line-vertical";
import MilestoneIconSVG from "assets/svg/milestone-icon-svg";
import PhotosIconSVG from "assets/svg/photos-icon-svg";
import TagIconSVG from "assets/svg/tag-icon-svg";
import ResumeIconSVG from "assets/svg/resume-icon-svg";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function DefaultTabs({
  profile,
  userData,
  selectedTab,
  isYourProfile,
  taggedMilestones,
  pendingCount = 0,
  setSelectedTab = () => {},
  checkDomain = () => {},
  emptyAbout = false
}) {
  const { t } = useTranslation();
  
  useEffect(()=>{
    checkCurrentTab();
  },[]);

  const checkCurrentTab = ()=>{
    if(checkDomain() && isYourProfile){
      return;
    }
    setSelectedTab("milestones");
  }

  return (
    <div className="profile-second-row w-full profile-page-wrapper-padding">
      <div className="w-full mt-5 bg-white rounded-md px-2 md:px-24.5 container-max-width">
        <div className="flex flex-row justify-center flex-nowrap items-center gap-x-2 4sm:gap-x-7.6">
          <TabSelector
            isActive={selectedTab === "milestones"}
            flex_1="flex-1 3sm:flex-none"
            gap="mr-0"
            colorType="black"
            paddingY="py-3 3sm:py-7.4 w-18.7 3sm:w-fit"
            onClick={() => setSelectedTab("milestones")}>
            <div className="w-full flex flex-col md:flex-row justify-center items-center text-4xs 3sm:text-sm md:text-base">
              <MilestoneIconSVG className="mb-1.6 md:mr-2 md:mb-0 h-[15px] w-[15px] 3sm:h-[22px] 3sm:w-[22px]"/>
              {t('milestones')}
            </div>
          </TabSelector>
          <div>
            <LineVerticalSVG />
          </div>
          { !emptyAbout && 
          <>
            <TabSelector
              flex_1="flex-1 3sm:flex-none"
              isActive={selectedTab === "about"}
              gap="mr-0"
              colorType="black"
              paddingY="py-3 3sm:py-7.4 w-18.7 3sm:w-fit"
              onClick={() => setSelectedTab("about")}>
              <div className="w-full flex flex-col md:flex-row justify-center items-center text-4xs 3sm:text-sm md:text-base">
                <AboutIconSVG className="mb-1.6 md:mr-2 md:mb-0 h-[15px] w-[15px] 3sm:h-[22px] 3sm:w-[22px]"/>
                {t('about')}
              </div>
            </TabSelector>
            <div>
              <LineVerticalSVG />
            </div>
          </>
          }
          
          <TabSelector
            isActive={selectedTab === "photos-video"}
            flex_1="flex-1 3sm:flex-none"
            gap="mr-0"
            colorType="black"
            paddingY="py-3 3sm:py-7.4 w-18.7 3sm:w-fit"
            onClick={() => setSelectedTab("photos-video")}>
            <div className="w-full flex flex-col md:flex-row justify-center items-center text-4xs 3sm:text-sm md:text-base">
              <PhotosIconSVG className="mb-1.6 md:mr-2 md:mb-0 text-2xs 3sm:text-sm h-[15px] w-[15px] 3sm:h-[22px] 3sm:w-[22px]"/>
              <span className="hidden 3sm:block"> {t('photosVideos')}</span>
              <span className="block 3sm:hidden">
              {t('photosVideos')}
              </span>
            </div>
          </TabSelector>

          {
            (((taggedMilestones ?? []).length > 0) || pendingCount > 0) && (
              <>
                <div>
                  <LineVerticalSVG />
                </div>
                <TabSelector
                  isActive={selectedTab === "tagged"}
                  flex_1="flex-1 3sm:flex-none"
                  gap="mr-0"
                  colorType="black"
                  paddingY="py-3 3sm:py-7.4 w-18.7 3sm:w-fit"
                  onClick={() => setSelectedTab("tagged")}>
                  <div className="w-full flex flex-col md:flex-row justify-center items-center text-4xs 3sm:text-sm md:text-base">
                    <TagIconSVG className="mb-1.6 md:mr-2 md:mb-0 text-2xs 3sm:text-sm h-[15px] w-[15px] 3sm:h-[22px] 3sm:w-[22px]"/>
                    <span className="hidden 3sm:block"> {t('tagged')}</span>
                    <span className="block 3sm:hidden">
                    {t('tagged')}
                    </span>
                    {pendingCount > 0 && (
                      <span className="ml-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red text-white text-[10px] font-bold flex items-center justify-center leading-none">
                        {pendingCount}
                      </span>
                    )}
                  </div>
                </TabSelector>
              </>
            )
          }

          {isYourProfile && (
            <>
              <div>
                <LineVerticalSVG />
              </div>
              <TabSelector
                isActive={selectedTab === "resume"}
                flex_1="flex-1 3sm:flex-none"
                gap="mr-0"
                colorType="black"
                paddingY="py-3 3sm:py-7.4 w-18.7 3sm:w-fit"
                onClick={() => setSelectedTab("resume")}>
                <div className="w-full flex flex-col md:flex-row justify-center items-center text-4xs 3sm:text-sm md:text-base">
                  <ResumeIconSVG className="mb-1.6 md:mr-2 md:mb-0 h-[15px] w-[15px] 3sm:h-[22px] 3sm:w-[22px]" />
                  {t('myResumes')}
                </div>
              </TabSelector>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
